<template>
    <div class="o-m-choose-point m-choose-point">
        <div 
            class="m-choose-point__wrapper"
            v-if="isHideElement"
        >
            <MExtremePoint
                v-model="searchValue"
                ref="extremePoint"
                searchbale
                clearable
                :disabled="!isMenu"
                :theme="mode"
                :label="textLabel"
                :placeholder="$t(`d-guide-search-placeholder--${mode}`)"
                :pointIcon="false"
                @onChange="handleInput"
                @onClear="onClear"
            />
        </div>
        <div class="m-choose-point__container">
            <component
                :id="id"
                :items="getItems"
                :is="defineComponent"
                :extras="extrasMainCategories"
                :filteredByItem="filteredByItem"
                :hasStrictResult="hasStrictResult"
                :isShowBlueLine="false"
                :isCloseButtonShow="true"
                @onServiceData="loadService"
                @onMenuClick="handleComponent"
                @onSearchTileClick="handleSearchTileClick"
                @onClickBack="handleClickBack"
                @changeExtremePoint="changeExtremePoint"
            />
        </div>
        <div 
            v-if="isShowFooter"
            class="m-choose-point__footer"
        >
            <AMBackButton
                theme="back"
                :text="$t('ui.back')"
                @onClick="$emit('onClickBack', true)"
            />
        </div>
    </div>
</template>

<script>
import {
    mapGetters,
    mapState
} from 'vuex';

import ALine from '../../atoms/a-line/a-line';
import OQrReader from '../../organisms/o-qr-reader/o-qr-reader';
import OService from '../../unique-organisms/o-m-service/o-m-service';
import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
import OMCare from '../../unique-organisms/o-mobile-care/o-mobile-care';
import OSearchresult from '../../organisms/o-searchresult/o-searchresult';
import MExtremePoint from '../../molecules/m-extreme-point/m-extreme-point';
import OServices from '../../unique-organisms/o-mobile-services/o-mobile-services';
import OMainCategoryMenu from '../../organisms/o-main-category-menu/o-main-category-menu';

import search from '../../../utils/mixins/search';

import { GUIDE_NEW_POINT } from "../../../utils/constants/bus-events-constants";

export default {
    name: 'OMChoosePoint',
    components: {
        ALine,
        OMCare,
        OService,
        OQrReader,
        OServices,
        AMBackButton,
        MExtremePoint,
        OSearchresult,
        OMainCategoryMenu
    },
    mixins: [search],
    data() {
        return {
            id: null,
            currentUnit: 'menu',
            menu: true,
            units: {
                care: 'OMCare',
                poster: 'OQrReader',
                service: 'OService',
                services: 'OServices',
                menu: 'OMainCategoryMenu',
                searchresult: 'OSearchresult'
            }
        }
    },
    props: {
        mode: {
            type: String,
            required: true
        },
        startPoint: {
            type: Object,
            default: () => ({})
        },
        finishPoint: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getMapConfigProp'
        ]),
        ...mapState({
            isLandscape: state => state.landscape,
        }),
        defineComponent() {
            return this.units[this.currentUnit]
        },
        isShowFooter() {
            return this.currentUnit === 'menu' || this.currentUnit === 'searchresult';
        },
        filteredByItem() {
            return this.$route.query.from ? parseInt(this.$route.query.from, 10) : null;
        },
        extrasMainCategories() {
            const isQrScanner = this.getMapConfigProp('features.qr_scanner', false);
            const poster = {
                name: 'poster',
                icon: 'icons/poster-category',
                description: false
            }
            return isQrScanner && this.mode === 'start' ? [poster] : []
        },
        textLabel() {
            return this.mode === 'start' ? this.$t('ui.start') : this.$t('ui.finish')
        },
        isMenu() {
            return this.currentUnit === 'menu'
                || this.currentUnit === 'searchresult'
                || this.currentUnit === 'care'
                || this.currentUnit === 'service'
                || this.currentUnit === 'services';
        },
        /**
        * We hide extremePoints and ALine in landscape when activete components: 'care', 'service', 'services'
        * @return Boolean
        */
        isHideElement() {
            return !(this.currentUnit === 'care' || this.currentUnit === 'service' || this.currentUnit === 'services');

        }
    },
    mounted() {
        this.focusAndSelectInputValue();
    },
    watch: {
        searchValue(data) {
            data && !this.menu ? this.currentUnit = 'searchresult' : this.currentUnit = 'menu';
        }
    },
    methods: {
        handleComponent(data) {
            if (data !== 'menu') this.menu = false;
            this.currentUnit = data;
        },
        handleClickBack() {
            this.currentUnit = 'menu'
            // this.$emit('onClickBack', true);
        },
        handleInput() {
            this.menu = !this.searchValue;
        },
        onClear() {
            this.searchValue = ''
            this.handleInput()
        },
        focusAndSelectInputValue() {
            this.$nextTick(() => {
                const el = this.$refs.extremePoint.$refs.extremePointInput;
                el.focus();
                el.setSelectionRange(0, this.searchValue.length);
            })
        },
        handleSearchTileClick(data) {
            if (data?.serviceCategory) {
                this.handleComponent('service');
                this.id = data.id;
            } else {
                this.$bus.$emit(GUIDE_NEW_POINT, data.id);
            }
        },
        loadService(data) {
            this.id = data.id;
            this.handleComponent('service');
        },
        changeExtremePoint() {
            this.$emit('changeExtremePoint')
        }
    }
}
</script>

<style lang="scss">
@import "o-m-choose-point";
</style>
